import { put, takeEvery } from 'redux-saga/effects';

import { ColorAction } from '../actions';
import { ColorConstant } from '../constants';

export default function* () {
  yield takeEvery(
    [ColorConstant.CREATE_COLOR_SUCCESS, ColorConstant.EDIT_COLOR_SUCCESS],
    createOrEditColorSuccess,
  );
  yield takeEvery(ColorConstant.DELETE_COLOR_SUCCESS, deleteColorSuccess);
  yield takeEvery(ColorConstant.GET_COLORS_SUCCESS, getColorsSuccess);
  yield takeEvery(ColorConstant.GET_COLOR_SUCCESS, getColorSuccess);
}

function* createOrEditColorSuccess() {
  yield put(ColorAction.setColor({}));
}

function* deleteColorSuccess() {
  yield put(ColorAction.getColors());
}

function* getColorsSuccess(action) {
  yield put(ColorAction.setColors(action?.payload));
}

function* getColorSuccess(action) {
  yield put(ColorAction.setColor(action?.payload));
}
